import Chart from "chart.js";

import tinymce from "tinymce";
import ProgramActModalView from "./programActModal.html";
import ProgramActMonitoringModalView from "./programActMonitoringModal.html";
import AddRestaurantModalView from "./addRestaurantModal.html";
import ProgramActMenuModalView from "./programActMenuModal.html";
import ProgramActReservationModalView from "./programActReservationModal.html";
import ProgramActUserModalView from "./programActUserModal.html";
import HistoricMailsModalView from "../common/historicMails.html";
import moment from 'moment-timezone';

angular.module("events")

    .controller("EventsProgramsActsListCtrl", ['LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', 'generateDocumentService', '$http', 'Upload', 'datasetsService', 'notificationService', 'logService',
        function (LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, generateDocumentService, $http, Upload, datasetsService, notificationService, logService) {

            $scope.programChangesNotSaved = false;
            $scope.eventChangesNotSaved = false;
            $scope.timezones = moment.tz.names();
            $scope.localZone = "(" + moment.tz.guess() + ")";

            $scope.setProgramChangesNotSaved = function () {
                $scope.programChangesNotSaved = true;
            };

            $scope.setEventChangesNotSaved = function () {
                $scope.eventChangesNotSaved = true;
            };

            $scope.toLocalTZDate = function (date, timezone) {
                let tzOffset = moment.tz.zone(timezone).utcOffset(new Date(date).getTime());
                let localTzOffset = moment.tz.zone(moment.tz.guess()).utcOffset(new Date(date).getTime());
                let localDate = moment(date).add(-localTzOffset, 'minutes').add(tzOffset, 'minutes').toDate();
                return localDate;
            };


            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_PROGRAM_ACT_WRITE");
            if (!Array.isArray($scope.$parent.menusItems)) {
                $state.go("events.edit", { id: $stateParams.id });
            } else {
                let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
                if (results.length > 0) {
                    $scope.allowWrite &&= results[0].editable;
                } else {
                    $scope.allowWrite = false;
                }
            }
            Restangular.all("DocumentsTypes").customGET("GetId", { code: "PROGRAM_ACTS" }).then(function (result) {
                $scope.documentTypeId = result;
            });
            $scope.loadProgramInfo = false;
            //Solo se carga todo esto si estamos en tasks, así evitamos que lo incluyan los calendarios.
            if ($state.current.name == 'events.edit.programs_acts') {

                Restangular.one('Events', $stateParams.id).get().then(function (results) {

                    $scope.event = results;

                    if ($scope.event.program_mail_list != null) {
                        $scope.event.program_mail_list_array = $scope.event.program_mail_list.split(",");
                    } else {
                        $scope.event.program_mail_list_array = [];
                    }

                    //$scope.showFile = false;
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('events.title'), url: "events.list" },
                        { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
                        { title: $filter('translate')('events.programs_acts.programs_acts') }
                    ];
                    $rootScope.title = $scope.event.name + " - " + $filter('translate')('events.programs_acts.programs_acts');

                });

                $scope.loadProgramsActs = function () {
                    Restangular.all('EventsProgramsActs').getList({ event_id: $stateParams.id }).then(function (result) {
                        $scope.eventsProgramsActs = result;
                        let lastDate = "";
                        $scope.eventsProgramsActsByDate = [];
                        angular.forEach($scope.eventsProgramsActs, function (eventProgramAct) {
                            let programDate = new Date(eventProgramAct.date).getFullYear() + "/" + new Date(eventProgramAct.date).getMonth() + "/" + new Date(eventProgramAct.date).getDate();
                            let programActs = [];
                            angular.forEach($scope.eventsProgramsActs, function (act) {
                                let actDate = new Date(act.date).getFullYear() + "/" + new Date(act.date).getMonth() + "/" + new Date(act.date).getDate();
                                let hoursZone = moment($scope.toLocalTZDate(act.date, $scope.event.timezone)).format("HH:mm");

                                if ($scope.event.timezone != "Europe/Madrid") {
                                    act.hoursZone = hoursZone;
                                } else {
                                    act.hoursZone = null;
                                }
                                if (programDate == actDate) {
                                    programActs.push(act);
                                }
                            });
                            if (programDate != lastDate) {
                                let program = {
                                    date: eventProgramAct.date,
                                    acts: programActs
                                }
                                $scope.eventsProgramsActsByDate.push(program);
                            }

                            lastDate = programDate;
                        });

                        //Images del programa
                        var eventProgramActIds = [];
                        angular.forEach(result, function (dataR) {
                            if (eventProgramActIds.indexOf(dataR.id) < 0) {
                                eventProgramActIds.push(dataR.id);
                            }
                        });
                        //Obtenemos sus imágenes
                        if (eventProgramActIds.length > 0) {
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'EventsProgramsActs/ImagesSmall',
                                params: { ids: eventProgramActIds }
                            }).then(function (resultsImage, status, headers, config) {
                                angular.forEach($scope.eventsProgramsActs, function (eventProgramAct) {
                                    for (var i = 0; i < resultsImage.data.length; i++) {
                                        if (eventProgramAct.id == resultsImage.data[i].event_program_act_id) {
                                            eventProgramAct.image_small = resultsImage.data[i].image_small;
                                            break;
                                        }
                                    }
                                });
                            });
                        }

                    });

                    Restangular.all('EventProgram').getList({ event_id: $stateParams.id }).then(function (eventProgram) {
                        if (eventProgram.length > 0) {
                            $scope.eventProgramInformation = eventProgram[0];
                            $scope.showFile = $scope.eventProgramInformation.filename != null;
                            $scope.eventProgramInformation.image = eventProgram[0].FK_events_programs_images != null ? eventProgram[0].FK_events_programs_images.image : null;
                        } else {
                            $scope.eventProgramInformation = {};
                            $scope.eventProgramInformation.event_id = $stateParams.id;
                        }
                    });
                }

                $scope.loadProgramsActs();

            }

            $scope.programAct = {};
            $scope.eventProgramInformation = {};

            $scope.classSize = "col-lg-12 col-md-12";
            function isDefinedAndNotNull(val) {
                return angular.isDefined(val) && val !== null
            }
            Restangular.one('Companies', $scope.company_id).get().then(function (results) {
                $scope.company = results;
            }, function (response) {
                $scope.errorMessage = response.message;
            });

            $scope.addEventProgramAct = function (id, event_program_act_date) {
                if (angular.isUndefined(event_program_act_date)) event_program_act_date = "";
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: ProgramActModalView,
                    controller: "ProgramActModalCtrl",
                    size: 'lg',
                    resolve: {

                        event_program_act_id: function () {
                            return id;
                        },
                        event: function () {
                            return $scope.event;
                        },
                        event_program_act_date: function () {
                            return event_program_act_date;
                        },
                        company: function () {
                            return $scope.company;
                        },

                    }

                });

                // Retorno de los datos desde el modal.

                $modalInstance.result.then(function (resultModal) {
                    if ($state.current.name == 'events.edit.programs_acts') $scope.loadProgramsActs();
                    if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    //  $scope.identity = {};
                });

            };

            /*
                * Si lleva el parámetro abro el elemento
            */

            if (angular.isDefined($stateParams.programActId) && $stateParams.programActId != null && $stateParams.programActId != "")
                $scope.addEventProgramAct($stateParams.programActId)

            // Modal de monitorización del acto

            $scope.seeActMonitoring = function (id) {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: ProgramActMonitoringModalView,
                    controller: "ProgramActMonitoringModalCtrl",
                    size: 'lg',
                    resolve: {
                        event_program_act_id: function () {
                            return id;
                        },
                        event: function () {
                            return $scope.event;
                        },
                        company: function () {
                            return $scope.company;
                        },
                    }
                });

            };

            //Delete desde el listado
            $scope.checkDeleteEventProgramAct = function (id, title) {
                $scope.id = id;
                $scope.title = title;
                modalService.confirm({
                    title: $filter('translate')('events.programs_acts.button_delete'),
                    message: $filter('translate')('events.programs_acts.delete_message') + " " + $scope.title + "?",
                    onAccept: function () {
                        Restangular.one('EventsProgramsActs', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('events.programs_acts.deleted_success'));
                            if ($state.current.name == 'events.edit.programs_acts') $scope.loadProgramsActs();
                        }, function (response) {
                            logService.error("Error with status code", response.status);
                            alert("Error al borrar")
                        });
                    }
                });

            };
            $scope.specificActChange = function () {
                $scope.eventsGuestsEspecificAct = [];
                Restangular.all('EventsProgramsActs').customGET("GetGuestsAct", { event_id: $scope.id }).then(function (result) {
                    angular.forEach(result, function (act) {
                        var style = "";
                        let nameComplete = act.name + " " + act.surname;
                        if (act.type == "show") {
                            style = "color: #CDCDCD;font-style: italic;";
                        }
                        $scope.eventsGuestsEspecificAct.push({ event_program_act_id: act.event_program_act_id, nameComplete: nameComplete, style: style });
                    });
                })
            }

            $scope.printDialog = function (code, type_document, type_result, id) {
                var params = {
                    entity_type: "events",
                    entity_type_id: $stateParams.id,
                    documents: { codes: [code] }
                };
                generateDocumentService.documentNew({
                    params: params,
                    onAccept: function (data) {
                        angular.forEach(data, function (item) {
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                                params: { document_id: item.document_id, event_id: params.entity_type_id, outputType: 'pdf' }
                            }).then(function (result, status, headers, config) {
                                var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                                window.open(url, '_blank');
                            });
                        })
                    }
                });
            }

            $scope.uploadFiles = function ($file) {
                $scope.file = $file;
                $scope.hasChanged = true;
                $scope.eventProgramInformation.filename = $scope.file.name;
                $scope.setProgramChangesNotSaved();
            }
            $scope.uploadFile = function (id, message) {

                if ($scope.hasChanged) {
                    $scope.showProgressBar = true;
                    $scope.file.upload = Upload.upload({
                        url: (window as any).CONFIG.api_url + "EventProgram/uploadFile",
                        data: { file: $scope.file, id: id },
                    });

                    $scope.file.upload.then(function (response) {
                        logService.debug(response.data);
                        toastr.success(message);
                        $scope.hasChanged = false;
                        $scope.file = undefined;
                        $scope.eventProgramInformation.file_uid = response.data.Uid;
                    }, function (response) {
                        if (response.status > 0) {
                            let errorMsg = response.status + ': ' + response.data;
                            toastr.error("Ha ocurrido un error: " + errorMsg);
                        }
                    }, function (evt) {
                        // Math.min is to fix IE which reports 200% sometimes
                        //$scope.file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)); // Ralentiza MUCHO la subida
                    });
                } else {

                    toastr.success(message);
                }
            }

            $scope.showFilePanel = function () {
                $scope.showFile = true;
            }

            $scope.deleteFile = function () {
                $scope.eventProgramInformation.filename = null;
                $scope.showFile = false;
                // $scope.saveEventProgram();
                $scope.setProgramChangesNotSaved();
            }

            $scope.downloadFile = function () {
                window.open((window as any).CONFIG.api_url + 'EventProgram/getFile?uid=' + $scope.eventProgramInformation.file_uid + '&filename=' + $scope.eventProgramInformation.filename, '_blank', '');
            }
            $scope.saveEventProgram = function () {
                if (angular.isDefined($scope.eventProgramInformation.id)) {
                    $scope.eventProgramInformation.put().then(function (result) {
                        if (typeof (result.id) != "undefined") {
                            $scope.uploadFile(result.id, $filter('translate')('events.programs_acts.edit_success'));
                            $scope.eventProgramInformation.file_uid = result.file_uid;
                        }
                        $scope.programChangesNotSaved = false;
                    });
                } else {
                    Restangular.all('EventProgram').post($scope.eventProgramInformation).then(function (result) {
                        if (typeof (result.id) != "undefined") {
                            var image = $scope.eventProgramInformation.image;
                            $scope.eventProgramInformation = result;
                            $scope.eventProgramInformation.image = image;
                            $scope.saveEventProgram();
                        }
                    });

                }
            }

            $scope.changeLoadProgramInfo = function () {
                $scope.loadProgramInfo = true;
            }

            // Prevent bootstrap dialog from blocking focusin
            $(document).on('focusin', function (e) {
                if ($(e.target).closest(".mce-window").length) {
                    e.stopImmediatePropagation();
                }
            });

            $scope.addImage = function (flowFile) {
                Restangular.all("FilesTypesWhitelist").customGET("GetTotalSizeAllowed", { entity: "programs" }).then(function (result) {

                    if (result.filter(e => e.type === flowFile.file.type).length <= 0) {
                        var typeAllowed = result.map(o => o.type).join(', ');
                        modalService.message({
                            title: "Error",
                            message: $filter('translate')('general.type_file_not_allowed') + "<br>" + typeAllowed,
                            onAccept: function () { }
                        });
                    } else {
                        var maxSizeAllowed = result.find(e => e.type === flowFile.file.type).maxsize;
                        var fileReader = new FileReader();
                        fileReader.onload = function (event) {
                            if (!event.target) return;
                            var image = new Image();
                            image.src = event.target.result as string;

                            image.onload = function () {
                                var sizeFileMB = flowFile.size / 1024;
                                if (sizeFileMB > 0) {
                                    //Comprobamos que no pase del tamaño limite de imagen
                                    if (sizeFileMB > maxSizeAllowed) {
                                        modalService.message({
                                            title: "Error",
                                            message: $filter('translate')('general.image_size_limit') + "<br>" + maxSizeAllowed + " Kb",
                                            onAccept: function () { }
                                        });
                                    } else {
                                        $scope.program_image = image.src;
                                        $scope.eventProgramInformation.image = image.src;
                                        // $scope.saveEventProgram();
                                        $scope.programChangesNotSaved = true;
                                        $scope.$apply();
                                    }
                                } else {
                                    $scope.program_image = image.src;
                                    $scope.eventProgramInformation.image = image.src;
                                    // $scope.saveEventProgram();
                                    $scope.programChangesNotSaved = true;
                                    $scope.$apply();
                                }
                            };
                        };
                        fileReader.readAsDataURL(flowFile.file);

                    }

                });

            };

            $scope.sendProgramDialog = function () {

                var params = {
                    entity_type: 'program',
                    entity_type_id: $scope.event.id,
                    addresses: $scope.event.program_mail_list,
                    mail_account_id: null,
                    mail_account_reply: null,
                    app_enabled: $scope.app_enabled,
                    documents: { for_event_guest: false }
                };

                notificationService.notificationMail({
                    params: params,
                    onAccept: function (data) {
                        toastr.success($filter('translate')('notifications.sending_mail_success'));
                    }
                });

            };

            $scope.deleteImage = function () {
                $scope.eventProgramInformation.image = null;
                $scope.setProgramChangesNotSaved();
                // $scope.saveEventProgram();
            }

            $scope.saveEvent = function () {

                if ($scope.event.program_mail_list_array.length > 0) {
                    $scope.event.program_mail_list = $scope.event.program_mail_list_array.join(', ');
                } else {
                    $scope.event.program_mail_list = null;
                    $scope.event.program_mail_list_array = [];
                };

                $scope.event.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        $scope.eventChangesNotSaved = false;
                        toastr.success($filter('translate')('events.edit_success'));
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });

            };

            $scope.saveEventAndProgram = function () {
                if ($scope.event.program_mail_list_array.length > 0) {

                    $scope.event.program_mail_list_array = $scope.event.program_mail_list_array.map(m => m.trim());
                    let invalidMails = $scope.event.program_mail_list_array.filter(m => !validateEmail(m))
                    if (invalidMails.length > 0) {

                        let titleString = $filter('translate')('general.error');
                        let messageString = $filter('translate')('general.invalid_emails_message') + ": " + invalidMails.join(', ');

                        return modalService.message({
                            title: titleString,
                            message: messageString,
                            onAccept: function () { }
                        });

                    }
                }

                $scope.saveEventProgram();
                $scope.saveEvent();

            }

            $scope.restoreDefaultProgramMails = function () {
                Restangular.all('Events').customGET("GetDefaultProgramMailList").then(function (result) {

                    if (result != null && result != "") {
                        $scope.event.program_mail_list_array = result.split(',');
                    } else {
                        $scope.event.program_mail_list_array = [];
                    }

                    $scope.setEventChangesNotSaved();

                })
            }

            let validateEmail = function (valor) {
                let emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (emailPattern.test(valor)) {
                    return true;
                } else {
                    return false;
                }
            };


        }])


    .controller("ProgramActModalCtrl", ['$timeout', 'generateDocumentService', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'event_program_act_id', 'event_program_act_date', 'event', 'company', 'uiSliderConfig', '$translate', 'gridService', '$uibModal', 'logService',
        function ($timeout, generateDocumentService, LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, event_program_act_id, event_program_act_date, event, company, uiSliderConfig, $translate, gridService, $uibModal, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_PROGRAM_ACT_WRITE");
            $scope.allowReadUsers = LoginService.permissionExist("EVENTS_PROGRAM_ACT_USER_READ") || LoginService.permissionExist("EVENTS_PROGRAM_ACT_USER_WRITE");
            $scope.allowWriteUsers = LoginService.permissionExist("EVENTS_PROGRAM_ACT_USER_WRITE");
            $scope.is_template = $stateParams.is_template == 'true';

            $scope.company = company;
            $scope.eventProgramAct = {};
            $scope.selectedTemplateModel = { add_images: false, template: "template_one_column" };
            $scope.template_options = [{ value: "template_one_column", name: $filter('translate')('events.programs_acts.one_column') }, { value: "template_two_column", name: $filter('translate')('events.programs_acts.two_column') }, { value: "template_three_column", name: $filter('translate')('events.programs_acts.three_column') }];
            $scope.files = [];

            $scope.eventProgramAct.translatable_program_acts = event.translatable_program_acts;

            if (angular.isUndefined(event_program_act_id) || event_program_act_id == "") {

                $scope.eventProgramAct.event_id = event.id;

                if (event_program_act_date != "") {
                    $scope.eventProgramAct.date = new Date(event_program_act_date);
                } else {
                    $scope.eventProgramAct.date = new Date(event.date_from);
                }
            }
            else {
                Restangular.one('EventsProgramsActs', event_program_act_id).get().then(function (results) {

                    $scope.eventProgramAct = results;
                    $scope.eventProgramAct.date = new Date($scope.eventProgramAct.date);
                    $scope.eventProgramAct.translatable_program_acts = event.translatable_program_acts;

                    //Image lateral del programa
                    let eventProgramActIds = [];
                    if ($scope.eventProgramAct.image_id != null) eventProgramActIds.push($scope.eventProgramAct.id);

                    //Obtenemos su imagen lateral
                    if (eventProgramActIds.length > 0) {
                        $http({
                            method: 'post',
                            url: (window as any).CONFIG.api_url + 'EventsProgramsActs/ImagesSmall',
                            params: { ids: eventProgramActIds, fullImg: true }
                        }).then(function (resultsImage, status, headers, config) {
                            $scope.eventProgramAct.FK_events_programs_acts_images = resultsImage.data[0];
                        });
                    }

                    if ($scope.eventProgramAct.template_images != "" && $scope.eventProgramAct.template_images != null) {
                        $scope.selectedTemplateModel.add_images = true;
                        $scope.selectedTemplateModel.template = $scope.eventProgramAct.template_images;
                        $http({
                            method: 'post',
                            url: (window as any).CONFIG.api_url + 'EventsProgramsActs/GetImagesTemplate',
                            params: { event_program_act_id: event_program_act_id, fullImg: true }
                        }).then(function (resultsImage, status, headers, config) {
                            $scope.files = resultsImage.data;
                        });
                    }

                });
            }

            $scope.addRestaurant = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddRestaurantModalView,
                    controller: "AddRestaurantModalCtrl",
                    size: 'lg'
                });
                $modalInstance.result.then(function (restaurant) {
                    Restangular.all('Restaurants').getList().then(function (results) {
                        $scope.selectRestaurants = results;
                        if (restaurant != null) $scope.programAct.restaurant_id = restaurant.id;
                    });
                }, function () {
                });
            };

            //Select del formato del acto

            $scope.gridOptionsActMenus = {
                pdfTitle: $filter('translate')('events.program_acts.menus_title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                enableSorting: true,
                paginationPageSizes: [5, 15, 30],
                paginationPageSize: 5,
                rowTemplate: '<div ng-dblclick="grid.appScope.addEventProgramActMenu(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    { name: 'name', displayName: $filter('translate')('events.programs_acts.menu_name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                    {
                        name: 'is_principal', field: 'is_principal', displayName: $filter('translate')('events.programs_acts.menu_is_principal'),
                        width: 100, enableFiltering: true,
                        cellTemplate: gridService.yesNoTemplate('is_principal')
                    },
                    {
                        name: ' ', width: 200, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('calendars.print'), action: 'ng-click="grid.appScope.printProgramActMenu(row.entity)"', cssIconClass: "fa fa-file" },
                            { title: $filter('translate')('events.button_edit'), action: 'ng-click="grid.appScope.addEventProgramActMenu(row.entity)"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('events.button_delete'), action: 'ng-click="grid.appScope.deleteEventProgramActMenu(row.entity);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {
                    var deferred = $q.defer();
                    options.event_program_act_id = event_program_act_id;
                    Restangular.all('EventsProgramsActsMenus').getList(options).then(function (result) {
                        var data = result;
                        data.totalRows = result.totalRows;
                        $scope.totalRows = result.totalRows;
                        deferred.resolve(data);
                    })

                    return deferred.promise;

                }
            };

            $scope.gridGuestAct = {
                pdfTitle: $filter('translate')('events.program_acts.guest_explicit_act'),
                exporterMenuCsv: true,
                exporterOlderExcelCompatibility: true,
                enableGridMenu: true,
                enableSorting: false,
                paginationPageSizes: [5, 15, 30],
                paginationPageSize: 5,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                exporterFieldCallback: function (grid, row, col, value) {
                    if (col.name == "surname") {
                        return row.entity.surname + " " + (row.entity.lastname != null ? row.entity.lastname : "") + ", " + row.entity.name;
                    }
                    return value;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    {
                        name: 'surname', displayName: $filter('translate')('events.programs_acts.users_name'), enableFiltering: false, enableHiding: false, enableColumnMenu: false,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope"> {{row.entity.surname}} {{row.entity.lastname}}, {{row.entity.name}}</div>',
                    },
                ],
                getData: function (options) {
                    var deferred = $q.defer();
                    if (angular.isDefined(event_program_act_id) && event_program_act_id !== null && event_program_act_id != "") {
                        logService.debug(event_program_act_id);
                        options.event_program_act_id = event_program_act_id;
                        Restangular.all('EventsProgramsActs').customGET("GetGuestsAct", { event_program_act_id: event_program_act_id }).then(function (result) {
                            var data = result;
                            data.totalRows = result.totalRows;
                            $scope.totalRows = result.totalRows;
                            deferred.resolve(data);
                        })
                    } else {
                        let data: any = [];
                        data.totalRows = 0;
                        deferred.resolve(data);
                    }
                    return deferred.promise;
                }
            };

            if ($scope.allowReadUsers) {
                $scope.gridOptionsActUsers = {
                    pdfTitle: $filter('translate')('events.program_acts.users_title'),
                    exporterMenuCsv: true,
                    enableGridMenu: true,
                    enableSorting: true,
                    paginationPageSizes: [5, 15, 30],
                    paginationPageSize: 5,
                    rowTemplate: '<div ng-dblclick="grid.appScope.addEventProgramActUser(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                    },
                    columnDefs: [
                        { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                        { name: 'FK_events_programs_acts_users_users.name', displayName: $filter('translate')('events.programs_acts.users_name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                        {
                            name: ' ', width: 200, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                                { title: $filter('translate')('events.button_edit'), action: 'ng-click="grid.appScope.addEventProgramActUser(row.entity)"', cssIconClass: "fa fa-edit" },
                                { title: $filter('translate')('events.button_delete'), action: 'ng-click="grid.appScope.deleteEventProgramActUser(row.entity);" ng-if="grid.appScope.allowWriteUsers"', cssIconClass: "fa fa-remove" }
                            ], { cssClass: "pull-right" })
                        },
                    ],
                    getData: function (options) {
                        var deferred = $q.defer();
                        options.event_program_act_id = event_program_act_id;
                        Restangular.all('EventsProgramsActsUsers').getList(options).then(function (result) {
                            var data = result;
                            data.totalRows = result.totalRows;
                            $scope.totalRows = result.totalRows;
                            deferred.resolve(data);
                        })
                        return deferred.promise;
                    }
                };

                $scope.gridOptionsActReservations = {
                    pdfTitle: $filter('translate')('events.program_acts.reservations_title'),
                    exporterMenuCsv: false,
                    enableGridMenu: true,
                    enableSorting: true,
                    paginationPageSizes: [5, 15, 30],
                    paginationPageSize: 5,
                    rowTemplate: '<div ng-dblclick="grid.appScope.addEventProgramActReservation(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                    }, // FK_locations_reservations_locations
                    columnDefs: [
                        { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                        { name: 'FK_locations_reservations_locations.name', displayName: $filter('translate')('events.location'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                        { name: 'date_from', displayName: $filter('translate')('events.date_from'), cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'', enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                        { name: 'date_to', displayName: $filter('translate')('events.date_to'), cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'', enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                        {
                            name: ' ', width: 200, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                                { title: $filter('translate')('events.button_edit'), action: 'ng-click="grid.appScope.addEventProgramActReservation(row.entity)"', cssIconClass: "fa fa-edit" },
                                { title: $filter('translate')('events.button_delete'), action: 'ng-click="grid.appScope.deleteEventProgramActReservation(row.entity);" ng-if="grid.appScope.allowWriteUsers"', cssIconClass: "fa fa-remove" }
                            ], { cssClass: "pull-right" })
                        },
                    ],
                    getData: function (options) {
                        var deferred = $q.defer();
                        options.event_program_act_id = event_program_act_id;
                        Restangular.all('LocationsReservations').getList(options).then(function (result) {
                            var data = result;
                            data.totalRows = result.totalRows;
                            $scope.totalRows = result.totalRows;
                            deferred.resolve(data);
                        })
                        return deferred.promise;
                    }
                };
            }

            Restangular.all('EventsProgramsActsTypes').getList().then(function (results) {
                $scope.selectProgramsActsTypes = results;
                if (angular.isUndefined($scope.eventProgramAct.FK_events_programs_acts_events_programs_acts_types) || $scope.eventProgramAct.FK_events_programs_acts_events_programs_acts_types == null) $scope.eventProgramAct.FK_events_programs_acts_events_programs_acts_types = results[0];
            });

            Restangular.all('Restaurants').getList().then(function (results) {
                $scope.selectRestaurants = results;
            });

            let color = (window as any).CONFIG_TINYMCE["no_company_id"].font_color_description;
            let font_size = (window as any).CONFIG_TINYMCE["no_company_id"].font_size;
            let font_family = (window as any).CONFIG_TINYMCE["no_company_id"].font_family;
            logService.debug((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")]);
            if (typeof ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")]) !== 'undefined') {
                if (typeof ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_color_description) !== 'undefined') {
                    color = (window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_color_description;
                }
                if (typeof ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_size) !== 'undefined') {
                    font_size = (window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_size;
                }
                if (typeof ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_family) !== 'undefined') {
                    font_family = (window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_family;
                }
            }

            $scope.tinymceDescriptionOptions = {
                resize: true,
                forced_root_block: 'p',
                //min_height: 60,
                //height: 60,
                schema: "html5",
                contextmenu: false,
                branding: false,
                formats: {
                    bold: { inline: 'b' },
                    underline: { inline: 'u' },
                    italic: { inline: 'i' },
                    alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "left" } },
                    aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "center" } },
                    alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "right" } },
                    alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "justify" } },
                },
                invalid_elements: 'strong,em',
                fontsize_formats: "8pt 10pt 12pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 25pt 28pt 30pt 36pt ",
                body_class: 'custom_tinymce_content',
                language: $translate.use().toLowerCase(), //Hay que customizarlo dependiendo del idioma...
                plugins: 'textcolor paste link lists advlist',
                toolbar: "undo redo |  fontsizeselect bold underline italic | forecolor | link | numlist bullist",
                menubar: false,
                paste_remove_styles: true, paste_remove_styles_if_webkit: true, paste_strip_class_attributes: true, paste_auto_cleanup_on_paste: true
            };

            $scope.tinymceTitleOptions = {
                resize: true,
                forced_root_block: 'p',
                contextmenu: false,
                branding: false,
                schema: "html5",
                relative_urls: false,
                remove_script_host: true,
                formats: {
                    bold: { inline: 'b' },
                    underline: { inline: 'u' },
                    italic: { inline: 'i' },
                    alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "left" } },
                    aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "center" } },
                    alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "right" } },
                    alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "justify" } },

                },
                invalid_elements: 'strong,em',
                fontsize_formats: "8pt 10pt 12pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 25pt 28pt 30pt 36pt ",
                body_class: 'custom_tinymce_content',
                language: $translate.use().toLowerCase(), //Hay que customizarlo dependiendo del idioma...
                // language_url: "Scripts/tinymce/langs/es.js",
                plugins: 'textcolor paste link lists advlist',
                toolbar: "undo redo |  fontsizeselect bold underline italic | forecolor | link | numlist bullist",
                menubar: false,
                paste_remove_styles: true, paste_remove_styles_if_webkit: true, paste_strip_class_attributes: true, paste_auto_cleanup_on_paste: true
            };

            /* Foto lateral */
            $scope.addImage = function (flowFile) {

                Restangular.all("FilesTypesWhitelist").customGET("GetTotalSizeAllowed", { entity: "programs" }).then(function (result) {

                    if (result.filter(e => e.type === flowFile.file.type).length <= 0) {
                        var typeAllowed = result.map(o => o.type).join(', ');
                        modalService.message({
                            title: "Error",
                            message: $filter('translate')('general.type_file_not_allowed') + "<br>" + typeAllowed,
                            onAccept: function () { }
                        });
                    } else {
                        var maxSizeAllowed = result.find(e => e.type === flowFile.file.type).maxsize;
                        var fileReader = new FileReader();
                        fileReader.onload = function (event) {
                            var image = new Image();
                            if (event.target && event.target.result) {
                                image.src = event.target.result as string;
                            }

                            image.onload = function () {
                                var sizeFileMB = flowFile.file.size / 1024;
                                if (sizeFileMB > 0) {
                                    //Comprobamos que no pase del tamaño limite de imagen
                                    if (sizeFileMB > maxSizeAllowed) {
                                        modalService.message({
                                            title: "Error",
                                            message: $filter('translate')('general.image_size_limit') + "<br>" + maxSizeAllowed + " Kb",
                                            onAccept: function () { }
                                        });
                                    } else {
                                        $scope.eventProgramAct.photo = image.src;
                                        if (angular.isUndefined($scope.eventProgramAct.FK_events_programs_acts_images) || $scope.eventProgramAct.FK_events_programs_acts_images == null) { $scope.eventProgramAct.FK_events_programs_acts_images = {}; }
                                        $scope.eventProgramAct.FK_events_programs_acts_images.image = image.src;
                                        if (!$scope.$$phase) $scope.$apply()

                                    }
                                } else {
                                    $scope.eventProgramAct.photo = image.src;
                                    if (angular.isUndefined($scope.eventProgramAct.FK_events_programs_acts_images) || $scope.eventProgramAct.FK_events_programs_acts_images == null) { $scope.eventProgramAct.FK_events_programs_acts_images = {}; }
                                    $scope.eventProgramAct.FK_events_programs_acts_images.image = image.src;
                                    if (!$scope.$$phase) $scope.$apply()
                                }
                            };
                        };

                        fileReader.readAsDataURL(flowFile.file);

                    }
                });
            };

            $scope.saveEventProgramAct = function () {

                $scope.eventProgramAct.event_program_act_type_id = $scope.eventProgramAct.FK_events_programs_acts_events_programs_acts_types.id;
                $scope.eventProgramAct.FK_events_programs_acts_menus_events_programs_acts = (typeof ($scope.gridOptionsActMenus) !== 'undefined' ? $scope.gridOptionsActMenus.data : null);
                $scope.eventProgramAct.FK_events_programs_acts_users_events_programs_acts = (typeof ($scope.gridOptionsActUsers) !== 'undefined' ? $scope.gridOptionsActUsers.data : null);
                $scope.eventProgramAct.FK_locations_reservations_event_program_act = (typeof ($scope.gridOptionsActReservations) !== 'undefined' ? $scope.gridOptionsActReservations.data : null);

                var save = true;
                if (angular.isDefined($scope.eventProgramAct.FK_events_programs_acts_menus_events_programs_acts) && $scope.eventProgramAct.FK_events_programs_acts_menus_events_programs_acts != null && $scope.eventProgramAct.FK_events_programs_acts_menus_events_programs_acts.length > 0) {
                    var principal = 0;
                    angular.forEach($scope.eventProgramAct.FK_events_programs_acts_menus_events_programs_acts, function (menu) {
                        if (menu.is_principal) {
                            principal++;
                        }
                    })
                    if (principal == 0 || principal > 1) save = false;
                }

                if (save) {
                    //comprobamos si todas las imagenes estan borradas, para quitarle el template_images que utiliza
                    let deleteTemplate = true;
                    if ($scope.files.length != 0) angular.forEach($scope.files, function (item) { if (!item.is_deleted) deleteTemplate = false; });
                    if (deleteTemplate) $scope.selectedTemplateModel.template = null;

                    $scope.eventProgramAct.template_images = $scope.selectedTemplateModel.template;
                    if (angular.isDefined($scope.eventProgramAct.id)) {
                        $scope.eventProgramAct.put().then(function (result) {
                            if (typeof (result.id) != "undefined") {
                                if ($scope.files.length > 0) {
                                    $scope.saveImages(result.id);
                                }
                                $uibModalInstance.close();
                                toastr.success($filter('translate')('events.programs_acts.edit_success'));
                            } else {
                                $scope.errorMessage = result.message;
                            }
                        });
                    } else {
                        Restangular.all('eventsProgramsActs').post($scope.eventProgramAct).then(function (result) {
                            if (typeof (result.id) != "undefined") {
                                if ($scope.files.length > 0) {
                                    $scope.saveImages(result.id);
                                }
                                $uibModalInstance.close();
                                toastr.success($filter('translate')('events.programs_acts.add_success'));
                            } else {
                                $scope.errorMessage = result.message;
                            }
                        });
                    }

                } else {
                    if (principal == 0) {
                        modalService.message({
                            title: "Error",
                            message: $filter('translate')('events.programs_acts.principal_info_message'),
                            onAccept: function () { }

                        });
                    } else {
                        modalService.message({
                            title: "Error",
                            message: $filter('translate')('events.programs_acts.unique_principal_info_message'),
                            onAccept: function () { }

                        });
                    }
                }
            }

            //Delete desde el popup
            $scope.checkDeleteEventProgramAct = function () {
                modalService.confirm({
                    title: $filter('translate')('events.programs_acts.button_delete'),
                    message: $filter('translate')('events.programs_acts.delete_message') + " " + $scope.eventProgramAct.title + "?",
                    onAccept: function () {
                        Restangular.one('EventsProgramsActs', event_program_act_id).remove({ send_notifications: $scope.eventProgramAct.send_notifications }).then(function () {
                            // $scope.eventProgramAct.remove().then(function () {
                            $uibModalInstance.close();
                        });
                    }
                });
            };

            $scope.addEventProgramActMenu = function (menu) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: ProgramActMenuModalView,
                    controller: "ProgramActMenuModalCtrl",
                    size: 'lg',
                    resolve: {
                        event_program_act_menu: function () { return menu; },
                        event_program_act_id: function () { return event_program_act_id; }
                    }
                });

                //Retorno de los datos desde el modal.
                $modalInstance.result.then(function (resultModal) {
                    if ((angular.isUndefined(resultModal.id) || resultModal.id == null) && resultModal.is_new) $scope.gridOptionsActMenus.data.push(resultModal);
                    if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    //  $scope.identity = {};
                });

            };

            //Delete menu desde el listado
            $scope.deleteEventProgramActMenu = function (menu) {
                modalService.confirm({
                    title: $filter('translate')('events.programs_acts.button_delete'),
                    message: $filter('translate')('events.programs_acts.menu_delete_message') + " " + menu.name + "?",
                    onAccept: function () {
                        $scope.gridOptionsActMenus.data.splice($scope.gridOptionsActMenus.data.indexOf(menu), 1);
                    }
                });
            };

            $scope.addEventProgramActReservation = function (reservation) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: ProgramActReservationModalView,
                    controller: "ProgramActReservationModalCtrl",
                    size: 'md',
                    resolve: {
                        event_program_act_reservation: function () {
                            return reservation;
                        },
                        event_program_act: function () {
                            return $scope.eventProgramAct;
                        }
                    }
                });

                // Retorno de los datos desde el modal.
                $modalInstance.result.then(function (resultModal) {
                    logService.debug(resultModal);
                    if ((angular.isUndefined(resultModal.id) || resultModal.id == null) && resultModal.is_new) $scope.gridOptionsActReservations.data.push(resultModal);
                    if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    //  $scope.identity = {};
                });
            }

            $scope.deleteEventProgramActReservation = function (reservation) {
                logService.debug(reservation);
            }

            /* users */
            $scope.addEventProgramActUser = function (user) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: ProgramActUserModalView,
                    controller: "ProgramActUserModalCtrl",
                    size: 'md',
                    resolve: {
                        event_program_act_user: function () {
                            return user;
                        },
                        event_program_act_id: function () {
                            return event_program_act_id;
                        }
                    }
                });

                //Retorno de los datos desde el modal.
                $modalInstance.result.then(function (resultModal) {
                    if ((angular.isUndefined(resultModal.id) || resultModal.id == null) && resultModal.is_new) $scope.gridOptionsActUsers.data.push(resultModal);
                    if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    //  $scope.identity = {};
                });
            };

            //Delete menu desde el listado
            $scope.deleteEventProgramActUser = function (user) {
                modalService.confirm({
                    title: $filter('translate')('events.programs_acts.button_delete'),
                    message: $filter('translate')('events.programs_acts.user_delete_message') + " " + user.FK_events_programs_acts_users_users.name + "?",
                    onAccept: function () {
                        $scope.gridOptionsActUsers.data.splice($scope.gridOptionsActUsers.data.indexOf(user), 1);
                    }
                });
            };

            $scope.printProgramActMenu = function (menu) {
                var params = {
                    entity_type: "events",
                    entity_type_id: $stateParams.id,
                    documents: { codes: "EVENT_MENU" }
                };
                generateDocumentService.documentNew({
                    params: params,
                    onAccept: function (data) {
                        angular.forEach(data, function (item) {
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                                params: { document_id: item.document_id, event_id: params.entity_type_id, program_menu_id: menu.id, outputType: 'pdf' }
                            }).then(function (result, status, headers, config) {
                                var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                                window.open(url, '_blank');
                            });
                        })
                    }
                });
            }

            $scope.showHistory = function (id) {
                let options: any = {}
                options.module = "program_acts/notify";
                options.code = id + "";
                options.event_id = $stateParams.id;

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: HistoricMailsModalView,
                    size: "lg",
                    controller: "historicMailsModalCtrl",
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        options: function () {
                            return options;
                        },
                    }
                });

                //Response del modal
                $modalInstance.result.then(function (data) {
                }, function () {
                    if (!$scope.$$phase) $scope.$apply();
                });
            }

            $scope.addImages = function (files, errFiles) {

                if (errFiles.length > 0) {
                    logService.debug("Ha ocurrido un error con las imágenes: ")
                    logService.debug(errFiles);
                } else {
                    Restangular.all("FilesTypesWhitelist").customGET("GetTotalSizeAllowed", { entity: "programs" }).then(function (result) {
                        angular.forEach(files, function (file, idx) {
                            if (result.filter(e => e.type === file.type).length <= 0) {
                                var typeAllowed = result.map(o => o.type).join(', ');
                                modalService.message({
                                    title: "Error",
                                    message: $filter('translate')('general.type_file_not_allowed') + "<br>" + typeAllowed,
                                    onAccept: function () { }
                                });
                            } else {
                                var maxSizeAllowed = result.find(e => e.type === file.type).maxsize;
                                var fileReader = new FileReader();
                                fileReader.onload = function (event) {
                                    if (!event.target) return;
                                    var image = new Image();
                                    image.src = event.target.result as string;

                                    image.onload = function () {
                                        var sizeFileMB = file.size / 1024;
                                        if (sizeFileMB > 0) {
                                            //Comprobamos que no pase del tamaño limite de imagen
                                            if (sizeFileMB > maxSizeAllowed) {
                                                modalService.message({
                                                    title: "Error",
                                                    message: $filter('translate')('general.image_size_limit') + "<br>" + maxSizeAllowed + " Kb",
                                                    onAccept: function () { }
                                                });
                                            } else {
                                                file.is_deleted = false;
                                                $scope.files.push(file);
                                                file.orden = idx;
                                                file.image = image.src;
                                                if (!$scope.$$phase) $scope.$apply()
                                            }
                                        } else {
                                            file.is_deleted = false;
                                            $scope.files.push(file);
                                            file.orden = idx;
                                            file.image = image.src;
                                            if (!$scope.$$phase) $scope.$apply()
                                        }
                                    };
                                };
                                fileReader.readAsDataURL(file);
                            }
                        });
                    });
                }
            };

            $scope.removeFile = function (file) {
                modalService.confirm({
                    title: "Borrar documento",
                    message: "¿Está usted seguro de querer borrar " + file.filename + "?",
                    onAccept: function () {
                        angular.forEach($scope.files, function (item) {
                            if (file.image == item.image) {
                                item.is_deleted = true;
                            }
                        });
                    }
                });
            }

            $scope.saveImages = function (eventProgramActId) {
                angular.forEach($scope.files, function (item) {
                    var epag = {
                        order: item.order,
                        event_program_act_id: eventProgramActId,
                        image_id: item.image_id,
                        image: item.image,
                        is_lateral: item.is_lateral,
                        is_deleted: item.is_deleted
                    }
                    $http({
                        method: 'post',
                        url: (window as any).CONFIG.api_url + 'EventsProgramsActs/SaveImagesTemplate',
                        data: epag
                    }).then(function (result, status, headers, config) { });
                });
            }

            $scope.onCancel = function () {
                tinymce.remove();
                $uibModalInstance.dismiss('cancel');
            };

        }])


    .controller("ProgramActMenuModalCtrl", ['generateDocumentService', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'event_program_act_menu', 'event_program_act_id', '$translate',
        function (generateDocumentService, LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, event_program_act_menu, event_program_act_id, $translate) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_PROGRAM_ACT_WRITE");

            if (angular.isUndefined(event_program_act_menu)) {
                $scope.eventProgramActMenu = {};
                $scope.eventProgramActMenu.is_new = true;
                $scope.eventProgramActMenu.id = null;
            } else {
                $scope.eventProgramActMenu = event_program_act_menu;
                $scope.eventProgramActMenu.is_new = false;
                $scope.eventProgramActMenu.title = "";
            }

            $scope.tinymceTitleOptions = {
                resize: true,
                forced_root_block: false,
                contextmenu: false,
                branding: false,
                min_height: 100,
                height: 100,
                body_class: 'custom_tinymce_content',
                language: $translate.use().toLowerCase(), //Hay que customizarlo dependiendo del idioma...
                plugins: 'textcolor paste ',
                toolbar: "undo redo fontsizeselect bold italic underline forecolor alignleft aligncenter alignright ",
                font_formats: 'Tahoma=Tahoma;Arial=arial,helvetica,sans-serif;Courier New=courier new,courier,monospace;',
                fontsize_formats: "8px 10px 12px 14px 15px 16px 18px 20px 22px 24px 25px 28px 30px 36px ",
                content_style: ".mce-content-body {font-size:14px;font-family:Tahoma;}",
                paste_remove_styles: true, paste_remove_styles_if_webkit: true, paste_strip_class_attributes: true, paste_auto_cleanup_on_paste: true,
                menubar: false
            }

            $scope.gridGuestMenu = {
                pdfTitle: $filter('translate')('events.program_acts.menu_guests') + " " + $scope.eventProgramActMenu.title,
                exporterPdfOrientation: 'portrait',
                exporterMenuCsv: true,
                enableGridMenu: true,
                enableSorting: true,
                paginationPageSizes: [10, 50, 100],
                paginationPageSize: 10,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    { name: 'name', displayName: $filter('translate')('events.programs_acts.guest_name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                    { name: 'surname', displayName: $filter('translate')('events.programs_acts.guest_surname'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                    { name: 'lastname', displayName: $filter('translate')('events.programs_acts.guest_lastname'), enableFiltering: true, enableHiding: false, enableColumnMenu: false }
                ],
                getData: function (options) {
                    var deferred = $q.defer();

                    if (typeof (event_program_act_id) == 'undefined') event_program_act_id = null;
                    options.event_program_act_id = event_program_act_id;
                    options.event_id = $stateParams.id;
                    options.event_program_act_menu_id = $scope.eventProgramActMenu.id;
                    $http({
                        method: 'get',
                        url: (window as any).CONFIG.api_url + 'EventsProgramsActsMenus/GetGuestFromMenu',
                        params: options
                    }).then(function (results, status, headers, config) {
                        var data = results.data;
                        deferred.resolve(data);
                    });

                    return deferred.promise;

                }
            };

            $scope.saveEventProgramActMenu = function () {
                if (angular.isUndefined($scope.eventProgramActMenu.event_program_act_id)) {
                    $scope.eventProgramActMenu.event_program_act_id = event_program_act_id;
                }
                $uibModalInstance.close($scope.eventProgramActMenu);
            }

            $scope.onCancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

        }])

    .controller("ProgramActUserModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'event_program_act_user', 'event_program_act_id', '$translate', 'logService',
        function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, event_program_act_user, event_program_act_id, $translate, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_PROGRAM_ACT_USER_WRITE");

            Restangular.all('Users').getList().then(function (results) {
                $scope.selectUsers = results;
            });


            if (angular.isUndefined(event_program_act_user)) {
                $scope.eventProgramActUser = {};
                $scope.eventProgramActUser.is_new = true;
                $scope.eventProgramActUser.id = null;
                $scope.eventProgramActUser.name_user = "";
            } else {
                $scope.eventProgramActUser = event_program_act_user;
                $scope.eventProgramActUser.is_new = false;
                //$scope.eventProgramActUser.name_user = "";
            }

            var font_size = (window as any).CONFIG_TINYMCE["no_company_id"].font_size;
            var font_family = (window as any).CONFIG_TINYMCE["no_company_id"].font_family;
            if (typeof ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")]) !== 'undefined') {
                if (typeof ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_size) !== 'undefined') {
                    font_size = (window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_size;
                }
                if (typeof ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_family) !== 'undefined') {
                    font_family = (window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_family;
                }
            }

            $scope.tinymceDescriptionOptions = {
                resize: true,
                contextmenu: false,
                branding: false,
                schema: "html5",
                formats: {
                    bold: { inline: 'b' },
                    underline: { inline: 'u' },
                    italic: { inline: 'i' },
                    alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "left" } },
                    aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "center" } },
                    alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "right" } },
                    alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "justify" } },
                },
                invalid_elements: 'strong,em',
                fontsize_formats: "8px 10px 12px 14px 15px 16px 18px 20px 22px 24px 25px 28px 30px 36px ",
                font_formats: 'Arial=Arial;Cambria=Cambria;Courier New=Courier New;Sans Serif=sans-serif;Segoe Script=Segoe Script;Tahoma=Tahoma;Verdana=Verdana',
                body_class: 'custom_tinymce_content',
                language: $translate.use().toLowerCase(), //Hay que customizarlo dependiendo del idioma...
                /*plugins: 'textcolor paste lists lists advlist nonbreaking preview',
                toolbar: "undo redo | fullscreen | fontsizeselect bold underline italic | numlist bullist | forecolor | alignleft aligncenter alignright alignjustify nonbreaking | paste pastetext | preview",*/
                plugins: 'textcolor paste link',
                toolbar: "undo redo |  fontsizeselect bold underline italic | forecolor | link",
                menubar: false,
                setup: function (ed) {
                    ed.on('init', function () {
                        this.execCommand("fontName", false, "sans-serif");
                        this.execCommand("fontSize", false, "10pt");
                    });
                },
            }
            $scope.saveEventProgramActUser = function () {
                if (angular.isUndefined($scope.eventProgramActUser.event_program_act_id)) {
                    $scope.eventProgramActUser.event_program_act_id = event_program_act_id;
                }
                if ($scope.eventProgramActUser.user_id != null) {
                    angular.forEach($scope.selectUsers, function (item) {
                        if (item.id == $scope.eventProgramActUser.user_id) $scope.eventProgramActUser.FK_events_programs_acts_users_users = { name: item.name };
                    });
                }
                logService.debug($scope.eventProgramActUser);

                $uibModalInstance.close($scope.eventProgramActUser);
            }

            $scope.onCancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

        }])
    .controller("ProgramActReservationModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'event_program_act_reservation', 'event_program_act', '$translate', 'logService',
        function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, event_program_act_reservation, event_program_act, $translate, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_PROGRAM_ACT_USER_WRITE");

            $scope.getLocationsSearch = function (val) {
                if (val == null) {
                    val = '';
                } else {
                    val = val.replace(/[:.?*+^$[\\(){|]/, "");
                }
                let ret = [];

                ret = Restangular.all('search/locations/' + val).getList().then(function (searchTerms) {
                    return searchTerms;
                });
                return ret;
            };

            $scope.locationSelected = function ($item, $model, $label) {
                $scope.isLocationSelected = true;
                /*                Restangular.all('Locations/' + $item.id + '/CheckAvailability').customGETLIST("",
                                    { date_from: $scope.event.date_from, date_to: $scope.event.date_to})
                                    .then(function (results) {
                                        if(angular.isArray(results) && results.length > 0) {
                                            $scope.locationAvailable = false;
                                            $scope.event.reserve = false;
                                        } else {
                                            $scope.locationAvailable = true;
                                        }
                                    });*/
                $scope.search.position_min_length = 0;
                $scope.eventProgramActReservation.location_id = $item.id;
                /*                Restangular.one('Locations', $item.id).get().then(function (results) {
                                    if (results.name !== undefined && results.length > 0) {
                                        $scope.search.locations = [];
                                        angular.forEach(results, function (row) {
                                            $scope.search.locations.push({
                                                id: row.id, // Este es el position_id de cara a luego usarlo para buscar el correo
                                                term: row.name
                                            });
                                        });
                
                                    }
                                });*/
            }

            if (angular.isUndefined(event_program_act_reservation)) {
                $scope.eventProgramActReservation = {};
                $scope.eventProgramActReservation.is_new = true;
                $scope.eventProgramActReservation.id = null;
                $scope.eventProgramActReservation.date_from = event_program_act.date;
                $scope.eventProgramActReservation.date_to = new Date(event_program_act.date.getTime() + event_program_act.duration * 60000);
                $scope.eventProgramActReservation.event_program_act_id = event_program_act.id;
                $scope.eventProgramActReservation.status = "confirmed";
            } else {
                $scope.eventProgramActReservation = event_program_act_reservation;
                $scope.eventProgramActReservation.is_new = false;
                //$scope.eventProgramActUser.name_user = "";
            }

            $scope.saveEventProgramActReservation = function () {
                logService.debug($scope.eventProgramActReservation);
                /*               if (angular.isUndefined($scope.eventProgramActUser.event_program_act_id)) {
                                   $scope.eventProgramActUser.event_program_act_id = event_program_act_id;
                               }
                               if ($scope.eventProgramActUser.user_id != null) {
                                   angular.forEach($scope.selectUsers, function (item) {
                                       if (item.id == $scope.eventProgramActUser.user_id) $scope.eventProgramActUser.FK_events_programs_acts_users_users = { name: item.name };
                                   });
                               }
                               logService.debug($scope.eventProgramActUser);*/

                $uibModalInstance.close($scope.eventProgramActReservation);
            }

            $scope.onCancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

        }])

    .controller("AddRestaurantModalCtrl", ['LoginService', '$scope', '$uibModalInstance', function (LoginService, $scope, $uibModalInstance) {
        $scope.allowWrite = LoginService.permissionExist("RESTAURANTS_WRITE");
        $scope.callbackClose = function (restaurant) {
            $uibModalInstance.close(restaurant);
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])

    .controller("ProgramActMonitoringModalCtrl", ['$timeout', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', 'event_program_act_id', 'event', 'company', '$uibModal', '$interval', 'filterFilter', 'datasetsService', 'logService',
        function ($timeout, LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, event_program_act_id, event, company, $uibModal, $interval, filterFilter, datasetsService, logService) {

            // Comprobamos si tiene permiso escritura
            $scope.company = company;
            $scope.eventProgramAct = {};
            $scope.files = [];

            $scope.eventProgramAct.translatable_program_acts = event.translatable_program_acts;

            // Monitorización propiamente dicha 

            $scope.totalRow = 0;
            $scope.invitedGuestNotInYet = 0;
            $scope.filterGuestsIn = 0;
            $scope.filterGuestsRejected = 0;
            $scope.totalGuestNotInYet = 0;
            $scope.totalGuestIn = 0;

            var barOptions = {
                scaleBeginAtZero: true,
                scaleShowGridLines: true,
                scaleGridLineColor: "rgba(0,0,0,.05)",
                scaleGridLineWidth: 1,
                barShowStroke: true,
                barValueSpacing: 5,
                barDatasetSpacing: 0,
                responsive: true,
                maintainAspectRatio: false,
                scaleOverride: true,
                scaleSteps: 10,
                scaleStartValue: 0,
                scales: {
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        },
                        ticks: {
                            min: 0,
                            beginAtZero: true,
                            callback: function (value, index, values) {
                                if (Math.floor(value) === value) {
                                    return value;
                                };
                            }
                        },

                    }]
                }
            };

            $scope.getGuestFilters = function (guests, type) {
                if (type == 'notin') {
                    var res = filterFilter(guests, { confirmation_status: 'confirmed' });
                    return filterFilter(res, { check_in_date: null }).length;
                } else if (type == 'in') {
                    var res = filterFilter(guests, { confirmation_status: 'confirmed' });
                    return filterFilter(res, { check_in_date: '!!' }).length;
                    //return filterFilter(guests, { confirmation_status: 'confirmed' } && { check_in_date: '!!' }).length; NO SE PONE ASI PORWUE NO LE GUSTA MAS DE UN FILTRO.
                } else {
                    var res = filterFilter(guests, { confirmation_status: '!confirmed' });
                    return filterFilter(res, { check_in_date: '!!' }).length;
                    //return filterFilter(guests, { confirmation_status: '!confirmed' } && { check_in_date: '!!' }).length; NO SE PONE ASI PORWUE NO LE GUSTA MAS DE UN FILTRO.
                }
            }
            $scope.getSerieColor = function (i) {
                var colors = [
                    "#ff7f27",
                    "rgba(151,187,205,1)",
                    "rgba(220,220,220,1)",
                    "rgba(247,70,74,1)",
                    "rgba(70,191,189,1)",
                    "rgba(253,180,92,1)",
                    "rgba(148,159,177,1)",
                    "rgba(77,83,96,1)"
                ];
                if (i >= colors.length) i = 0;
                return colors[i];
            };


            $scope.loadChart = function () {

                Restangular.all('EventsProgramsActs').customGET("GetGuestsAct", { event_program_act_id: event_program_act_id }).then(function (results) {

                    let searchedData = `${$scope.dateSearch.getDate()}/${$scope.dateSearch.getMonth()}/${$scope.dateSearch.getFullYear()}`;

                    let dataResults = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

                    //Filtramos los invitados que han accedido al evento
                    let data = results.filter(r => r.check_in_date);

                    // Les añadimos los datos relevantes 
                    data.forEach(d => {
                        let date = new Date(d.check_in_date);
                        d.hour = date.getUTCHours();
                        d.date = `${date.getUTCDate()}/${date.getUTCMonth()}/${date.getUTCFullYear()}`;
                    });

                    // Aplicamos el filtro de fecha
                    let filteredData = data.filter(d => d.date == searchedData);

                    // Rellenamos los datos de la gráfica

                    filteredData.forEach(d => {
                        dataResults[d.hour] = dataResults[d.hour] + 1;

                    });

                    var barData = {
                        labels: ["0h", "1h", "2h", "3h", "4h", "5h", "6h", "7h", "8h", "9h", "10h", "11h", "12h", "13h", "14h", "15h", "16h", "17h", "18h", "19h", "20h", "21h", "22h", "23h"],
                        datasets: [{
                            label: "Número de asistentes",
                            data: dataResults,
                            backgroundColor: `#23c6c8`
                        }]
                    };

                    const canvas = document.getElementById("barChart") as HTMLCanvasElement;
                    const ctx = canvas.getContext("2d");
                    if ($scope.myNewChart != null) {
                        $scope.myNewChart.destroy();
                    }
                    //@ts-ignore
                    $scope.myNewChart = new Chart(ctx, {
                        type: "bar",
                        data: barData,
                        options: barOptions
                    });
                });
            }

            $scope.dateSearch = new Date();
            $scope.loadChart();

            $scope.loadGuests = function () {

                Restangular.all('EventsProgramsActs').customGET("GetGuestsAct", { event_program_act_id: event_program_act_id }).then(function (results) {

                    results.forEach(function (guest) {

                        if (guest.check_in_date != null) {
                            guest.check_in_dat = new Date(guest.check_in_date).toLocaleDateString("es-Es")
                        }
                    })

                    $scope.invitedGuests = results;

                    logService.debug($scope.invitedGuests);
                    $scope.invitedGuestNotInYet = $scope.getGuestFilters($scope.invitedGuests, 'notin');
                    $scope.filterGuestsIn = $scope.getGuestFilters($scope.invitedGuests, 'in');
                    $scope.filterGuestsRejected = $scope.getGuestFilters($scope.invitedGuests, 'rejected');
                    $scope.totalGuestNotInYet = ($scope.invitedGuestNotInYet / ($scope.invitedGuestNotInYet + $scope.filterGuestsIn) * 100);
                    $scope.totalGuestIn = ($scope.filterGuestsIn / ($scope.invitedGuestNotInYet + $scope.filterGuestsIn) * 100);

                });
            }

            $scope.loadGuests();
            let intervalLoadInfoDashboard = $interval(function () { $scope.loadGuests(); $scope.loadChart(); }, (window as any).CONFIG.time_check_changes_guests);

            $scope.changeAssistance = function (id, route) {
                modalService.confirm({
                    title: $filter('translate')('events.guests.warning'),
                    message: $filter('translate')('events.resume.change_confirm'),
                    onAccept: function () {
                        Restangular.all("EventsResume").customGET(route, { id: id }).then(function () {
                            toastr.success($filter('translate')('events.resume.modified_successful'));
                            $scope.loadGuests(); $scope.loadChart();
                        });
                    }
                });
            };

            $scope.export = function () {
                let options = {
                    filters: {
                        ACT_ID: event_program_act_id,
                    }
                };

                datasetsService.exportByType("act_resume", options);
            };

            //Cuando salga del events, se destruirá el intervalo.
            $scope.$on("$destroy", function () {
                if (angular.isDefined(intervalLoadInfoDashboard)) {
                    $interval.cancel(intervalLoadInfoDashboard);
                    intervalLoadInfoDashboard = undefined;
                }
            });

            $scope.onCancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

        }])


    .filter('unsafe', ['$sce', function ($sce) { return $sce.trustAsHtml; }]);


;